export default "__VITE_ASSET__CepwM_O8__"